import deepDiff from 'deep-diff';
import { camelCaseToSentence } from 'lib/string';
import type { DiffConfig, HistoryDataChange } from './types';

export const CHANGES_ACTIONS_MAP = {
    N: 'added',
    D: 'removed',
    E: 'modified',
    A: 'modified',
} as const;

export function getHistoryChanges<T>(previous: T, current: T): HistoryDataChange[] {
    const diffList = deepDiff.diff(previous, current);

    if (!diffList) {
        return [];
    }

    return diffList.reduce<HistoryDataChange[]>((all, diff) => {
        if (!diff.path) {
            return all;
        }

        const path = diff.path.join('.');
        const action = CHANGES_ACTIONS_MAP[diff.kind];

        return [...all, { path, action }];
    }, []);
}

export function formatHistoryChanges(
    allChanges: HistoryDataChange[],
    { maxDepthPaths, ignoredFields }: DiffConfig
): HistoryDataChange[] {
    return allChanges.reduce<HistoryDataChange[]>((all, change) => {
        const maxDepthPath = maxDepthPaths.find((_path) => change.path.includes(_path));
        const path = maxDepthPath || change.path;

        if (all.find((_change) => _change.path === path) || ignoredFields.find((field) => path.startsWith(field))) {
            return all;
        }

        return [...all, { ...change, path }];
    }, []);
}

export function createGetChangeFieldName(fieldNameMap: Record<string, string>) {
    return function getChangeFieldName(path: string): string {
        const field = fieldNameMap[path] || path.split('.').pop();
        return camelCaseToSentence(field);
    };
}
